module.exports = __webpack_public_path__ + "static/media/Team 17 - 4Sydney.c141cc86.png";